<canvas #myCanvas style="width: 500px; height:400px;"></canvas>
<img class="canvas-bg" [src]="bg" draggable="false">